import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import {
  RuleSummary,
  RulesActionTypes,
  RetrieveTriggeredAlertsResponse,
  RuleEntitiesWhitelistPayload,
  RuleValidationAlertEntitiesPayload,
  RuleValidationAlertEntitiesResponse,
  DeployShadowRulePayload,
  RetrieveRulesPayload,
  RuleParametersAdditionalFields,
  SetEditingRulePayload,
} from 'app/modules/rules/models';
import { PaginationPayload } from 'app/shared/pagination/models';

export const setDynamicColumnDefinitionId = (id: number) => {
  return createAction(RulesActionTypes.SET_DYNAMIC_COLUMN_DEFINITION_ID, id);
};

export const deployShadowRule = (payload: DeployShadowRulePayload) => {
  return createAction(RulesActionTypes.DEPLOY_SHADOW_RULE, payload);
};

export const deployShadowRuleSuccess = (payload: RuleSummary) => {
  return createAction(RulesActionTypes.DEPLOY_SHADOW_RULE_SUCCESS, payload);
};

export const retrieveRules = (payload: RetrieveRulesPayload) =>
  createAction(RulesActionTypes.RETRIEVE_RULES, payload);

export const retrieveComponentRules = (payload: RetrieveRulesPayload) =>
  createAction(RulesActionTypes.RETRIEVE_COMPONENT_RULES, payload);

export const retrieveComponentRulesSuccess = (result) =>
  createAction(RulesActionTypes.RETRIEVE_COMPONENT_RULES_SUCCESS, result);

export const setAdditionalFieldsInRuleParameters = (
  payload: RuleParametersAdditionalFields,
) => {
  return createAction(
    RulesActionTypes.SET_ADDITIONAL_FIELDS_IN_RULE_PARAMETERS,
    payload,
  );
};

export const retrieveTriggeredAlerts = (
  id: number,
  payload: PaginationPayload,
) => createAction(RulesActionTypes.RETRIEVE_TRIGGERED_ALERTS, { id, payload });

export const retrieveTriggeredAlertsPending = () =>
  createAction(RulesActionTypes.RETRIEVE_TRIGGERED_ALERTS_PENDING);

export const retrieveTriggeredAlertsSuccess = (
  payload: RetrieveTriggeredAlertsResponse,
) => {
  return createAction(
    RulesActionTypes.RETRIEVE_TRIGGERED_ALERTS_SUCCESS,
    payload,
  );
};

export const retrieveTriggeredAlertsError = () =>
  createAction(RulesActionTypes.RETRIEVE_TRIGGERED_ALERTS_ERROR);

export const setEditingRule = (payload: SetEditingRulePayload) =>
  createAction(RulesActionTypes.SET_EDITING_RULE, payload);

export const whitelistEntitiesForRule = (
  payload: RuleEntitiesWhitelistPayload,
) => {
  return createAction(RulesActionTypes.WHITELIST_ENTITIES_FOR_RULE, payload);
};

export const whitelistEntitiesForRuleSuccess = () =>
  createAction(RulesActionTypes.WHITELIST_ENTITIES_FOR_RULE_SUCCESS);

export const retrieveRuleValidationAlertEntities = (
  payload: RuleValidationAlertEntitiesPayload,
) => {
  return createAction(
    RulesActionTypes.RETRIEVE_RULE_VALIDATION_ALERT_ENTITIES,
    payload,
  );
};

export const retrieveRuleValidationAlertEntitiesSuccess = (
  payload: RuleValidationAlertEntitiesResponse,
) => {
  return createAction(
    RulesActionTypes.RETRIEVE_RULE_VALIDATION_ALERT_ENTITIES_SUCCESS,
    payload,
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RulesActionsList = {
  retrieveRules,

  retrieveComponentRules,
  retrieveComponentRulesSuccess,

  setDynamicColumnDefinitionId,

  setEditingRule,

  retrieveTriggeredAlerts,
  retrieveTriggeredAlertsPending,
  retrieveTriggeredAlertsSuccess,
  retrieveTriggeredAlertsError,

  retrieveRuleValidationAlertEntitiesSuccess,

  setAdditionalFieldsInRuleParameters,
};
export type RulesActions = ActionsUnion<typeof RulesActionsList>;
export default RulesActions;
